/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FeaturesConfigService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get All Apps
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAllAppsV1FeaturesConfigAppsGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/features_config/apps',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
                422: `Validation Error`,
                500: `Server Internal Error`,
                503: `Service Not Available`,
            },
        });
    }

    /**
     * Get App Features Config
     * @param appToken 
     * @param appName 
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAppFeaturesConfigV1FeaturesConfigAppFeaturesConfigAppTokenAppNameGet(
        appToken: string,
        appName: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/features_config/app-features-config/{app_token}/{app_name}',
            path: {
                'app_token': appToken,
                'app_name': appName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
                422: `Validation Error`,
                500: `Server Internal Error`,
                503: `Service Not Available`,
            },
        });
    }

    /**
     * Update App Features Config
     * @param appToken 
     * @param appName 
     * @param requestBody 
     * @returns any Successful Response
     * @throws ApiError
     */
    public updateAppFeaturesConfigV1FeaturesConfigAppFeaturesConfigAppTokenAppNamePut(
        appToken: string,
        appName: string,
        requestBody: any,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v1/features_config/app-features-config/{app_token}/{app_name}',
            path: {
                'app_token': appToken,
                'app_name': appName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
                422: `Validation Error`,
                500: `Server Internal Error`,
                503: `Service Not Available`,
            },
        });
    }

    /**
     * Sync S3 App Features Config
     * @param appToken 
     * @param appName 
     * @param requestBody 
     * @returns any Successful Response
     * @throws ApiError
     */
    public syncS3AppFeaturesConfigV1FeaturesConfigSyncS3AppTokenAppNamePut(
        appToken: string,
        appName: string,
        requestBody: any,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v1/features_config/sync-s3/{app_token}/{app_name}',
            path: {
                'app_token': appToken,
                'app_name': appName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
                422: `Validation Error`,
                500: `Server Internal Error`,
                503: `Service Not Available`,
            },
        });
    }
}
